module.exports = __webpack_public_path__ + "static/MR_APR19_Once_600x600px-9a4794b3a8ed5d0028f2d51511d11257.jpg";